export const getShareContent = (listingName: string, listingUrl: string) => {
  const shareContent = `The listing "${listingName}" is on ListnDeal site. Check it out at ${listingUrl} to get more details and have a chance to make a deal!`;
  const emailContent = `Hello,\n\nDo you know this listing ${listingName} is available on ListnDeal?\nPlease check it out at ${listingUrl} to get more details and have a chance to make a deal. `;
  const emailSubject = `Enjoy a chance to get a deal with the listing ${listingName} on ListnDeal!`;

  return { emailContent, emailSubject, shareContent };
};
